'use strict';

var React = require('react');

var SvgImageAltMinor = function SvgImageAltMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 11a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1v-4a1 1 0 1 1 2 0v3h1zm5-4a1 1 0 1 1 0 2h-1v3a1 1 0 1 1-2 0v-3h-1a1 1 0 1 1 0-2h4zm-11.105.553 2 4a1 1 0 0 1-1.79.895l-.222-.448h-1.764l-.224.448a1 1 0 0 1-1.79-.895l2-4c.34-.678 1.45-.678 1.79 0z"
  }));
};

exports.SvgImageAltMinor = SvgImageAltMinor;
